module.exports = __webpack_public_path__ + "img/x-erro.30dcc78a.svg";